import { ReactComponent as Icon } from "../files/star-outline.svg";

import ISVGIconProps from "../ISVGIconProps";

const OutlinedStar = ({ fill, style = {} }: ISVGIconProps) => {
    return <Icon style={style} fill={fill} />;
};

export default OutlinedStar;
